<template>
  <div class="order-list-page">
    <van-nav-bar title="订单列表" @click-left="onClickLeft" />

    <div class="content-wrap">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list :class="orderList.length === 0 ? 'order-list' : ''" v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="onLoad">
          <van-checkbox-group ref="checkboxGroup" v-model="checkedIds" @change="onCheckChange">
            <div class="order-card" v-for="item in orderList" :key="item.order_id" @click="onOrderClick(item)">
              <div class="order-check">
                <!-- <van-checkbox v-model="item.checked" @change="onCheckChange"></van-checkbox> -->
                <van-checkbox :name="item.order_id" @click.stop></van-checkbox>
              </div>
              <div class="order-info">
                <div class="order-row">
                  <span class="label">订单号</span>
                  <span class="value">{{ item.order_id }}</span>
                </div>
                <div class="order-row">
                  <span class="label">订单金额</span>
                  <span class="value price">¥{{ item.pay_price }}</span>
                  <!-- <span class="label ml16">支付方式</span>
                <span class="value">{{ item.pay_type_name }}</span> -->
                </div>
                <!-- <div class="order-row">
                  <span class="label">订单状态</span>
                  <span class="value" :class="statusClass(item.status)">
                    {{ statusText(item.status) }}
                  </span>
                </div> -->
                <div class="order-row">
                  <span class="label">订单时间</span>
                  <span class="value">{{ formatTime(item.add_time) }}</span>
                  <!-- <span class="label ml16">状态</span>
                <span class="value" :class="statusClass(item.status)">
                  {{ statusText(item.status) }}
                </span> -->
                </div>
                <div class="order-row">
                  <span class="label">收货人</span>
                  <span class="value">{{ item.real_name }}</span>
                  <!-- <span class="label ml16">电话</span>
                <span class="value">{{ item.user_phone }}</span> -->
                </div>
                <!-- <div class="order-row">
                <span class="label">地址</span>
                <span class="value">{{ item.user_address }}</span>
              </div> -->

                <div class="order-row">
                  <span class="label">支付方式</span>
                  <span class="value">{{ item.pay_type_name }}</span>
                </div>
              </div>
            </div>
          </van-checkbox-group>
        </van-list>
      </van-pull-refresh>
    </div>

    <div class="bottom-bar" v-if="orderList.length > 0">
      <div class="select-info">
        <van-checkbox v-model="allChecked" @click="onAllCheck"> 全选 ({{ checkedCount }}) </van-checkbox>
      </div>
      <van-button type="info" :disabled="checkedCount === 0" @click="onSubmit"> 下一步 </van-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { NavBar, PullRefresh, List, Checkbox, Button, Toast, CheckboxGroup } from "vant";
import { getCurrentDateTime } from "@/utils";

Vue.use(NavBar);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Button);
Vue.use(Toast);

export default {
  name: "OrderList",
  data() {
    return {
      uid: localStorage.getItem("uid") || "",

      orderList: [],
      pageindex: 1,
      pagesize: 10,
      loading: false,
      finished: false,
      refreshing: false,
      allChecked: false,

      checkedIds: [],
      isAll: false,
    };
  },
  computed: {
    checkedCount() {
      //   return this.orderList.filter((item) => item.checked).length;
      return this.checkedIds.length;
    },
  },
  created() {
    if (this.$route?.query?.uid) this.uid = this.$route.query.uid;
    if (this.uid) {
      localStorage.setItem("uid", this.uid);
    } else {
      Toast("未知用户");
    }
    localStorage.removeItem("orderIds");
    localStorage.removeItem("totalPrice");
    localStorage.removeItem("kpwcInfo");

    this.loading = true;
    this.onRefresh();
  },
  methods: {
    onClickLeft() {
      this.$router.back();
    },
    onLoad() {
      this.loading = true;
      this.$axios
        .post(window.xheader + "/api/Invoice/GetOrderList", {
          uid: this.uid,
          pageindex: String(this.pageindex),
          pagesize: String(this.pagesize),
        })
        .then((res) => {
          if (res.Result === 1 && res.data && res.data.length > 0) {
            this.orderList = this.orderList.concat(res.data);
            this.pageindex++;
            this.allChecked = false;
          } else {
            this.finished = true;
          }
        })
        .catch(() => {
          Toast("网络异常,请重试");
          this.finished = true;
        })
        .finally(() => {
          this.loading = false;
          this.refreshing = false;
        });
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pageindex = 1;
      this.orderList = [];
      this.checkedIds = [];
      this.onLoad();
    },
    onCheckChange(names) {
      this.allChecked = this.orderList.length > 0 && names.length === this.orderList.length;
      this.isAll = this.allChecked;
    },
    onAllCheck() {
      this.isAll = !this.isAll;
      this.$refs.checkboxGroup.toggleAll(this.isAll);
    },
    onOrderClick(item) {
      if (this.checkedIds.includes(item.order_id)) {
        this.checkedIds = this.checkedIds.filter((id) => id !== item.order_id);
      } else {
        this.checkedIds.push(item.order_id);
      }
    },
    onSubmit() {
      if (this.checkedIds.length === 0) {
        Toast("请选择订单");
        return;
      }
      const selected = this.orderList.filter((item) => this.checkedIds.includes(item.order_id));
      const orderIds = this.checkedIds.join(",");
      const totalPrice = selected.reduce((acc, item) => acc + Number(item.pay_price), 0);
      localStorage.setItem("totalPrice", totalPrice.toFixed(2));
      localStorage.setItem("orderIds", orderIds);
      //   Toast(`已选择 ${selected.length} 条订单，单号: ${orderIds}`);
      this.$router.push({ path: "/fplr", query: { uid: this.uid } });
    },
    formatTime(timestamp) {
      if (!timestamp) return "";
      return getCurrentDateTime(timestamp);
    },
    statusText(status) {
      const map = { 0: "待处理", 1: "已完成", 2: "已取消" };
      return map[status] || "未知";
    },
    statusClass(status) {
      if (status === 1) return "status-done";
      if (status === 2) return "status-cancel";
      return "status-pending";
    },
  },
};
</script>

<style lang="less" scoped>
.order-list-page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f6f6f7;
}

.content-wrap {
  flex: 1;
  overflow-y: auto;
}

.order-list {
  min-height: calc(100vh - 50px);
}

.order-card {
  display: flex;
  align-items: flex-start;
  background: #fff;
  margin: 10px 12px;
  border-radius: 8px;
  padding: 12px;
  box-sizing: border-box;

  .order-check {
    margin-right: 10px;
    padding-top: 2px;
  }

  .order-info {
    flex: 1;
    min-width: 0;
  }

  .order-row {
    display: flex;
    align-items: center;
    font-size: 13px;
    line-height: 22px;
    color: #323233;

    .label {
      color: #969799;
      flex-shrink: 0;
      margin-right: 10px;
    }

    .value {
      color: #323233;
      word-break: break-all;
    }

    .ml16 {
      margin-left: 16px;
    }

    .price {
      color: #ee0a24;
      font-weight: 500;
    }

    .status-done {
      color: #07c160;
    }

    .status-cancel {
      color: #969799;
    }

    .status-pending {
      color: #ff976a;
    }
  }
}

.bottom-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  background: #fff;
  padding: 0 16px;
  border-top: 1px solid #ebedf0;
  box-sizing: border-box;

  .select-info {
    font-size: 14px;
  }

  .van-button {
    padding: 0 24px;
  }
}
</style>
